import React from "react";
import PropTypes from "prop-types";
import SidePanel from "components/sidePanel";
import { ReactComponent as DownloadIcon } from "images/profile/document-download.svg";
import { useTranslation } from "react-i18next";
import FileIcon from "utils/iconHelper";
import projectsApi from "api/projects";
import useNotify from "hooks/useNotify";

function ReferenceFilesPanel({ isOpen, onClose, files = [] }) {
  const [t] = useTranslation();
  const { notifyError } = useNotify();

  async function downloadFileInANewTab(fileId) {
    try {
      const fileUrl = await projectsApi.gitRefFileUrlApi(fileId);
      window.open(fileUrl, "_blank");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    }
  }

  return (
    <SidePanel
      isOpen={isOpen}
      onClose={onClose}
      title={t("referenceFilesTitle")}
      width={354}
    >
      <div className="p-5 flex flex-col divide-y divide-[#F1F1F3]">
        {files?.length === 0 && (
          <div className="text-[#666666] text-sm">{t("noReferenceFiles")}</div>
        )}
        {files?.map((f) => (
          <div
            key={f.id || f.fileId || f.name}
            className="flex items-center justify-between py-3"
          >
            <div className="flex items-center gap-2 text-[#1D1B22]">
              <FileIcon fileName={f.name} />
              <span className="text-sm truncate max-w-[260px]" title={f.name}>
                {f.name}
              </span>
            </div>
            <button
              className="p-1 rounded hover:bg-[#F3F5F7]"
              onClick={() => downloadFileInANewTab(f.fileId || f.id)}
              aria-label="Download file"
            >
              <DownloadIcon />
            </button>
          </div>
        ))}
      </div>
    </SidePanel>
  );
}

ReferenceFilesPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  files: PropTypes.array,
};

export default ReferenceFilesPanel;
